import React from 'react';
import { motion } from 'framer-motion';
import { FaGlobe, FaShieldAlt, FaPlane } from 'react-icons/fa';

const ShippingPage = () => {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }} className="min-h-screen bg-deepDark pt-20 pb-32">
      <div className="max-w-4xl mx-auto px-4">
        
        <div className="text-center mb-20">
          <p className="text-gold text-[10px] tracking-widest uppercase mb-4">Global Logistics</p>
          <h1 className="text-5xl md:text-6xl font-serif text-white tracking-wide mb-8">Shipping Integrity</h1>
          <div className="w-16 h-[1px] bg-gold mx-auto"></div>
        </div>

        <div className="bg-surfaceDark border border-white/5 p-10 md:p-16 mb-16">
          <p className="text-textMuted text-lg font-light leading-relaxed text-center italic">
            "Acquiring a piece of LuxeJewels is a momentous occasion. We ensure the voyage to your hands is as pristine and secure as the masterpiece itself."
          </p>
        </div>

        <div className="space-y-16">
          <div className="flex flex-col md:flex-row gap-8 items-start">
            <div className="w-16 h-16 rounded-full bg-[#0a0a0a] border border-gold/30 flex items-center justify-center text-gold flex-shrink-0">
              <FaShieldAlt size={24} />
            </div>
            <div>
              <h2 className="text-2xl font-serif text-white mb-4">Insured Transit</h2>
              <p className="text-textMuted font-light leading-relaxed">
                Every acquisition dispatched from our vault is comprehensively insured up to its full appraisal value by Lloyd's of London. You assume zero liability during transit until the package is securely signed for by you or your authorized representative.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-8 items-start">
            <div className="w-16 h-16 rounded-full bg-[#0a0a0a] border border-gold/30 flex items-center justify-center text-gold flex-shrink-0">
              <FaPlane size={24} />
            </div>
            <div>
              <h2 className="text-2xl font-serif text-white mb-4">Express Airborne Delivery</h2>
              <p className="text-textMuted font-light leading-relaxed">
                We utilize private courier networks and armed transport when necessary. Domestic (EU/US) deliveries typically arrive within 24-48 hours post-dispatch. Discretion is maintained via unmarked packaging ensuring utmost security.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-8 items-start">
            <div className="w-16 h-16 rounded-full bg-[#0a0a0a] border border-gold/30 flex items-center justify-center text-gold flex-shrink-0">
              <FaGlobe size={24} />
            </div>
            <div>
              <h2 className="text-2xl font-serif text-white mb-4">International Duties</h2>
              <p className="text-textMuted font-light leading-relaxed">
                LuxeJewels operates under DDP (Delivered Duty Paid) protocols for over 40 countries, meaning all import taxes, customs duties, and local levies are pre-calculated and settled by our firm. The price you see at checkout is the absolute final cost.
              </p>
            </div>
          </div>
        </div>

      </div>
    </motion.div>
  );
};

export default ShippingPage;
